export const getRoomLabelNumber = (label: string): string => {
  if (
    label.split(' ')[label.split(' ').length - 1] !== undefined &&
    label.split(' ')[label.split(' ').length - 1].match(/^\d/)
  ) {
    return label.split(' ')[label.split(' ').length - 1]
  }
  return ''
}
